module.exports = __webpack_public_path__ + "img/m4_t2_bg.b7341ebc.svg";